var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasicImageAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "22xm8vda4a",
    d: "M0 0H32V32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-704.000000, -344.000000) translate(508.000000, 328.000000) translate(196.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uh4n1zzd1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#22xm8vda4a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.667 4C5.196 4 4 5.196 4 6.667v18.666C4 26.804 5.196 28 6.667 28h18.666C26.804 28 28 26.804 28 25.333V6.667C28 5.196 26.804 4 25.333 4H6.667zm0 2.667h18.666l.003 18.666H6.666V6.667zM12 17.333l-4 5.334h16l-6.667-9.334-4 5.334L12 17.333zm1.333-4.666c0-1.105-.895-2-2-2-1.104 0-2 .895-2 2 0 1.104.896 2 2 2 1.105 0 2-.896 2-2z",
    mask: "url(#uh4n1zzd1b)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicImageAlt);
export default __webpack_public_path__ + "static/media/basic-image-alt.b2f743d5.svg";
export { ForwardRef as ReactComponent };